// Generic reducers for plain data slices.
// Custom behavior belongs in the corresponding file in /slices.
// TODO: standardize the remaining data slices onto these where the lifecycle is plain.
// These do not handle concurrency — stale responses can overwrite newer ones.

export function handleRequest(state, { payload: { loadingName, additionalStates = {} } }) {
  return {
    ...state,
    [loadingName]: true,
    ...additionalStates,
  };
}

export function handleAvailable(
  state,
  { payload: { keyState, data, loadingName, additionalStates = {} } },
) {
  return {
    ...state,
    [keyState]: data,
    [loadingName]: false,
    ...additionalStates,
  };
}

export function handleUnavailable(
  state,
  {
    payload: { keyState, loadingName, defaultState = [], additionalStates = {} },
  },
) {
  return {
    ...state,
    [keyState]: defaultState,
    [loadingName]: false,
    ...additionalStates,
  };
}
